const faqs = [
  {
    q: '91樱花动漫需要下载APP或注册账号吗？',
    a: '完全不需要。91樱花动漫支持直接通过浏览器在线观看所有动漫内容，无需下载安装任何客户端或插件，也不需要注册账号。打开网页即可开始追番，简单便捷。',
  },
  {
    q: '动漫在线观看的画质怎么样？有广告吗？',
    a: '本站动漫资源均支持高清1080P画质播放，画面清晰流畅。同时我们坚持纯净追番理念，全程无弹窗广告和恶意跳转，为您提供沉浸式的动漫观看体验。',
  },
  {
    q: '动漫全集更新的速度有多快？',
    a: '我们保持与日本播出同步更新，最新动漫在线看资源通常在播出后数小时内上线。日常维护团队每日追踪动漫网站更新动态，确保番剧在线资源及时到位。',
  },
  {
    q: '手机上可以流畅观看吗？',
    a: '可以的。91樱花动漫全面适配移动端浏览器，无论使用手机还是平板，都能获得流畅的高清动漫观看体验。播放器针对移动网络做了优化，省流量的同时保证画质。',
  },
  {
    q: '站内的动漫资源都有哪些类型？',
    a: '本站资源覆盖热播新番、经典老番、剧场版、OVA等丰富类型。题材涵盖热血、治愈、悬疑、搞笑、恋爱、奇幻等多元方向，满足不同漫迷的在线看动漫需求。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            关于91樱花动漫的常见疑问解答
          </p>
        </div>
        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6"
            >
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0">Q:</span>
                <span>{faq.q}</span>
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex items-start gap-2">
                <span className="text-accent-500 flex-shrink-0">A:</span>
                <span>{faq.a}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}